import React from "react";
import AuthLayout from "./AuthLayout";
import PasswordIcon from "../../assets/auth/password-success.svg";
import { useNavigate } from "react-router-dom";

const PasswordResetSuccess = () => {
    const navigate = useNavigate();
  return (
    <AuthLayout>
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="text-center max-w-2xl w-full">
          {/* Success Icon */}
          <div className="mx-auto w-[126px] h-[126px] bg-green-100 rounded-full flex items-center justify-center mb-6">
            <img
              src={PasswordIcon}
              alt="Help Illustration"
              className="mx-auto"
            />
          </div>

          {/* Success Message */}
          <h1 className="text-[48px] nunito-extrabold text-[#0A0A0A] max-w-[551px] justify-center mx-auto mb-2 ">
            Your password has been successfully reset!
          </h1>

          {/* Subtitle */}
          <p className="text-[#696969] mb-8 text-[24px] nunito-regular  mx-auto">
            You can now log in with your new password
          </p>

          {/* Login Button */}
          <button
            className="w-[320px] h-[40px] bg-[#F15D18] text-white text-[16px] nunito-bold py-2 px-4 rounded-[8px] hover:bg-orange-600 transition-colors"
            onClick={() => navigate("/signin")}	
          >
            Login
          </button>
        </div>
      </div>
    </AuthLayout>
  );
};

export default PasswordResetSuccess;
